import React from "react";
import { Chip, Tooltip } from "@mui/material";

import { getOmissionReason } from "./omissionReasons";

const REASON_BADGE_COLOR = {
  no_product_name: "default",
  unresolved_product: "warning",
  no_closest_product: "warning",
  no_record_at: "info",
  future_record_at: "info",
  no_canonical_retailer: "secondary",
  invalid_price: "error",
  protected_row: "success",
  barcode_unsupported: "error",
};

const OmissionReasonChip = ({ code }) => {
  const reason = getOmissionReason(code);

  return (
    <Tooltip title={reason.meaning || reason.label} arrow placement="top">
      <Chip
        size="small"
        label={reason.label}
        color={REASON_BADGE_COLOR[code] || "default"}
      />
    </Tooltip>
  );
};

export default OmissionReasonChip;
